var exports = {
  "k": "xfd349460--9f6c80--container",
  "i": "xfd349460--9f6c80--wrapper",
};

module.exports = exports;
